import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'audienceSelect',
    'scheduleMessageSection',
    'scheduleMessageInput',
    'messageButton',
    'scheduleMessageButton',
    'scheduleMessageInfo',
    'scheduleMessageTime',
    'scheduleModal',
    'scheduleDate',
    'scheduleTime',
    'callyCalendar',
    'calendarContainer',
    'dateDisplay',
    'saveButton',
  ];

  connect() {
    if (this.scheduleMessageInputTarget.value) {
      this.#displayScheduledDateTime();
    }
    this.#setupCallyCalendar();
    this.#updateSaveButtonState();
  }

  #setupCallyCalendar() {
    if (this.hasCallyCalendarTarget) {
      this.callyCalendarTarget.addEventListener('change', (e) => {
        this.scheduleDateTarget.value = e.target.value;
        // Update the date display with formatted date
        if (e.target.value) {
          const selectedDate = new Date(e.target.value);
          const formattedDate = selectedDate.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
          });
          this.dateDisplayTarget.value = formattedDate;
          this.calendarContainerTarget.classList.add('hidden');
          this.#updateSaveButtonState();
        }
      });
    }

    this.scheduleTimeTarget.addEventListener('change', () => {
      this.#updateSaveButtonState();
    });
  }

  #updateSaveButtonState() {
    const dateValue = this.scheduleDateTarget.value;
    const timeValue = this.scheduleTimeTarget.value;

    this.saveButtonTarget.disabled = dateValue === '' || timeValue === '';
  }

  toggleCalendar(event) {
    event.preventDefault();
    event.stopPropagation();
    this.calendarContainerTarget.classList.toggle('hidden');
  }

  scheduleMessage(event) {
    if (this.scheduleMessageInputTarget.value) {
      if (event.target.closest('.clear-schedule-btn')) {
        this.#removeSchedule(event);
        return;
      }
    }
    this.#openScheduleModal();
  }

  clearSchedule(event) {
    event.preventDefault();
    event.stopPropagation();
    this.#removeSchedule(event);
  }

  saveSchedule() {
    const date = this.scheduleDateTarget.value;
    const time = this.scheduleTimeTarget.value;

    if (!date || !time) {
      return;
    }

    const dateTime = `${date}T${time}`;
    this.scheduleMessageInputTarget.value = dateTime;

    this.#displayScheduledDateTime();
    this.#closeScheduleModal();
  }

  #displayScheduledDateTime() {
    if (!this.scheduleMessageInputTarget.value) return;

    const dateObj = new Date(this.scheduleMessageInputTarget.value);
    const formattedDate = dateObj.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    this.messageButtonTarget.innerText = 'Schedule Message';
    this.scheduleMessageTimeTarget.innerHTML = `
      ${formattedDate}
    `;
    this.scheduleMessageInfoTarget.classList.remove('hidden');
    this.scheduleMessageButtonTarget.classList.add('hidden');
  }

  #removeSchedule(event) {
    if (event) {
      event.stopPropagation();
    }

    this.scheduleMessageInputTarget.value = '';
    this.dateDisplayTarget.value = '';
    this.scheduleTimeTarget.value = '';
    this.messageButtonTarget.innerText = this.messageButtonTarget.dataset.text;
    this.scheduleMessageInfoTarget.classList.add('hidden');
    this.scheduleMessageButtonTarget.classList.remove('hidden');
  }

  #openScheduleModal() {
    this.scheduleModalTarget.showModal();
  }

  #closeScheduleModal() {
    this.scheduleModalTarget.close();
  }
}
